import { useSelector } from "react-redux";

export function useUserDetail() {
  const { user } = useSelector((state) => ({
    user: state.user,
  }));

  return {
    ...user,
    name: user?.isLoggedIn ? `${user.givenName} ${user.surname}` : "",
  };
}
